
var PayrollExportFormatter = {
    reportToRows: function(report) {
        var user = null;
        if (report.get('userId')) {
            if (Core.client && Core.client.users) {
                user = Core.client.users.get(report.get('userId'));
                if (!user) {
                    Core.client.users.fetchAndCache();
                    user = Core.client.users.get(report.get('userId'));
                }
            }
        }
        return this.createRowForReport(report, user);
    },

    createRowForReport: function(report, user) {
        var extraRows = [];
        var items = [];

        if (report.get('items') && report.get('items').length > 1) {
            items = report.get('items').slice(1);
        }

        extraRows = this.generateExtraReportRow(report, items, []);

        var rows = [];
        var row = this.createRowForReportOrExtra(report, user);
        if(row) rows.push(row);
        var self = this;
        extraRows.forEach(function(extraRow) {
            row = self.createRowForReportOrExtra(extraRow, user);
            if(row) rows.push(row);
        });

        return rows;
    },

    generateExtraReportRow: function(report, items, extraRows) {
        var temp = new WorkReport();
        temp.id = report.id;
        temp.attributes.workDate = report.get("workDate");

        if (items && items.length <= 0) {
            return extraRows;
        }

        if (items && items.length > 0) {
            temp.items = [];
            temp.items.push(items.pop());
        }
        extraRows.push(temp);
        return this.generateExtraReportRow(report, items, extraRows);
    },


    createRowForReportOrExtra: function(report, user) {
        var items = report.get('items') ? report.get('items') : report.items ? report.items : null;
        if (items && items.length > 0){
            var article = items[0];
            if(article.articlePayroll){
                var headerRow = [];
                var dataRow = [];
                headerRow.push(i18next.t('reportExcelExportMapping_date'));
                if (report.get('workDate')) {
                    var workDate = new Date(report.get('workDate'));
                    var dayOfWeek = i18next.t('weekDayArray_' + new Date(workDate).getDay());
                    var date = Formatting.datePart(workDate);
                    dataRow.push(dayOfWeek + ' ' + date);
                } else {
                    dataRow.push('');
                }
                
                headerRow.push(i18next.t('reportExcelExportMapping_user'));
                dataRow.push(user && user.get("fullName") ? user.get("fullName") : '');
                headerRow.push(i18next.t('userName'));
                dataRow.push(user && user.get("userName") ? user.get("userName") : '');
                headerRow.push(i18next.t('personalIdentificationNo'));
                dataRow.push(user && user.get('personalIdentificationNo') ? user.get('personalIdentificationNo') : '');

                headerRow.push(i18next.t('reportExcelExportMapping_articleNo'));
                dataRow.push(article.articleNo ? article.articleNo : '');

                headerRow.push(i18next.t('reportExcelExportMapping_articleDescription'));
                dataRow.push(article.description ? article.description : '');

                headerRow.push(i18next.t('reportExcelExportMapping_articleUnit'));
                dataRow.push(article.unit ? i18next.t('reportUnitShort_' + article.unit) : '');

                headerRow.push(i18next.t('reportExcelExportMapping_articleAmount'));
                dataRow.push(article.amount ? article.amount : '');  
                return [headerRow, dataRow]
            }
        }
        else {
            var absence = report.get('type') ? report.get('type') == "ABSENCE" : report.type ? report.type == "ABSENCE": false;
            if(absence){
                var headerRow = [];
                var dataRow = [];
                headerRow.push(i18next.t('reportExcelExportMapping_date'));
                if (report.get('workDate')) {
                    var workDate = new Date(report.get('workDate'));
                    var dayOfWeek = i18next.t('weekDayArray_' + new Date(workDate).getDay());
                    var date = Formatting.datePart(workDate);
                    dataRow.push(dayOfWeek + ' ' + date);
                } else {
                    dataRow.push('');
                }
                
                headerRow.push(i18next.t('reportExcelExportMapping_user'));
                dataRow.push(user && user.get("fullName") ? user.get("fullName") : '');
                headerRow.push(i18next.t('userName'));
                dataRow.push(user && user.get("userName") ? user.get("userName") : '');
                headerRow.push(i18next.t('personalIdentificationNo'));
                dataRow.push(user && user.get('personalIdentificationNo') ? user.get('personalIdentificationNo') : '');

                headerRow.push(i18next.t('reportExcelExportMapping_articleNo'));
                dataRow.push(report.get("activityCode") ? report.get("activityCode") : '');

                headerRow.push(i18next.t('reportExcelExportMapping_articleDescription'));
                dataRow.push(report.get("activityName") ? report.get("activityName") : '');

                headerRow.push(i18next.t('reportExcelExportMapping_articleUnit'));
                dataRow.push(i18next.t('reportUnitShort_HOURS'));

                headerRow.push(i18next.t('reportExcelExportMapping_articleAmount'));
                dataRow.push(report.get("workDuration") ? report.get("workDuration")/60 : '');  
                return [headerRow, dataRow]
            }
        }
        return null;
    },
};